exports["Dictionary"] = Dictionary;
exports["TreeWalker"] = TreeWalker;
exports["TreeTransformer"] = TreeTransformer;
exports["minify"] = minify;
exports["_push_uniq"] = push_uniq;



//////////////////
// WEBPACK FOOTER
// ./~/html-minifier/~/uglify-js/tools/exports.js
// module id = 1449
// module chunks = 0